import { render, staticRenderFns } from "./CustomFieldItemForm.vue?vue&type=template&id=aa45810c&scoped=true&"
import script from "./CustomFieldItemForm.vue?vue&type=script&lang=js&"
export * from "./CustomFieldItemForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa45810c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa45810c')) {
      api.createRecord('aa45810c', component.options)
    } else {
      api.reload('aa45810c', component.options)
    }
    module.hot.accept("./CustomFieldItemForm.vue?vue&type=template&id=aa45810c&scoped=true&", function () {
      api.rerender('aa45810c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CustomField/CustomFieldItemForm.vue"
export default component.exports